/** The centred card that Login and Register share. */
export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="auth-shell">
      <div className="auth-panel">
        <div className="auth-brand">
          <svg viewBox="0 0 40 40" className="auth-strand" aria-hidden="true">
            <path
              d="M20 4c-6 6-6 10 0 16s6 10 0 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M12 6c-4 6-4 12 0 18s4 10 0 14"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              opacity="0.55"
            />
            <path
              d="M28 6c4 6 4 12 0 18s-4 10 0 14"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              opacity="0.55"
            />
          </svg>
          <div>
            <div className="auth-name">Vipin Hair Extension</div>
            <div className="auth-tag">Inventory System</div>
          </div>
        </div>

        <h1 className="auth-title">{title}</h1>
        {subtitle && <p className="auth-subtitle">{subtitle}</p>}

        {children}

        {footer && <div className="auth-footer">{footer}</div>}
      </div>
    </div>
  );
}
